import { Typography } from 'antd';
import React from 'react';
import AlumlyBreadCrumb, { PathT } from '../../../components/AlumlyBreadCrumb';
import { RouteNameEnum } from '../../../enums/routeName';
import FormCreateNotification from '../components/FormCreateNotification';

const CreateNotification: React.FC = () => {
  const path: PathT[] = [
    {
      label: 'Notification',
      value: RouteNameEnum.notification.index,
    },
    {
      label: 'create notification',
    },
  ];
  return (
    <div>
      <AlumlyBreadCrumb path={path} />
      <Typography.Title level={4} style={{ fontWeight: 'bold', margin: 0 }}>Create notification</Typography.Title>
      <FormCreateNotification />
    </div>
  );
};

export default CreateNotification;
